/* Created by Interactive 63 - https://interactive63.com */
/**
 * A small modal that asks for one line of text, such as a name. It resolves with the text when
 * confirmed, or null when cancelled with the button or Escape.
 */
import { h } from './dom';

export interface PromptOptions {
  title: string;
  label: string;
  value: string;
  confirmLabel: string;
}

/** Shows the dialog and waits for an answer. */
export function promptDialog(options: PromptOptions): Promise<string | null> {
  return new Promise((resolve) => {
    const input = h('input', { type: 'text', value: options.value, autocomplete: 'off' });
    const confirm = h('button', { type: 'button', class: 'primary' }, options.confirmLabel);
    const cancel = h('button', { type: 'button' }, 'Cancel');
    const dialog = h(
      'dialog',
      { class: 'message-dialog prompt-dialog', 'aria-labelledby': 'prompt-dialog-title' },
      h('h3', { id: 'prompt-dialog-title' }, options.title),
      h('label', { class: 'prompt-field' }, h('span', null, options.label), input),
      h('div', { class: 'dialog-actions' }, cancel, confirm),
    );
    let answer: string | null = null;
    confirm.addEventListener('click', () => {
      answer = input.value;
      dialog.close();
    });
    cancel.addEventListener('click', () => {
      dialog.close();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        confirm.click();
      }
    });
    dialog.addEventListener('close', () => {
      dialog.remove();
      resolve(answer);
    });
    document.body.append(dialog);
    dialog.showModal();
    input.focus();
    input.select();
  });
}
